module.exports = __webpack_public_path__ + "static/media/neoception.3fb3a402.svg";